import {EntityData, field, SearchModel, SearchResult} from "@fedelta-pos/data-client";
import {Injectable, Injector, inject} from "@angular/core";
import {firstValueFrom} from 'rxjs';

export enum BeaconOrderType {
    TABLE_ONLY = "TABLE_ONLY",
    PICKUP_ONLY = "PICKUP_ONLY",
    TABLE_OR_PICKUP_ONLY = "TABLE_OR_PICKUP_ONLY"
}

export class BeaconData extends EntityData<BeaconData> {
    @field id: string;
    @field appStore: number;
    @field appStoreGroup: string;
    @field orderType: BeaconOrderType;
    @field tableLookupCode: string;
    @field dealCode: string;
}

/**
 * Search model to look up a beacon
 */
@Injectable()
export class BeaconSearchModel extends SearchModel<BeaconData> {
    constructor() {
        console.log("--- BeaconSearchModel");
        super(inject(Injector), BeaconData);
    }

    async lookupBeacon(id: string): Promise<BeaconData> {
        const searchResult: SearchResult = await firstValueFrom(super.searchRecords({"id": id}, undefined, undefined, undefined));
        return searchResult.totalCount ? searchResult.data[0] : null;
    }
}
